import { Component, OnInit, ViewChild, ElementRef, Renderer2, EventEmitter, Output} from '@angular/core';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { AuthService } from '@auth0/auth0-angular';

@Component({
  selector: 'app-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.sass']
})
export class NavComponent implements OnInit {
  SearchForm = new FormGroup({
    search: new FormControl(''),
    category: new FormControl('')
  })

  searching : String
  categoryVal: String
  empty = true;
  totalMessages = 0
  totalPosts = 0

  profilePages = {
    post: 1,
    message: 1
  }

  navVal = ''
  @ViewChild('about', {read: ElementRef}) about;
  @ViewChild('aboutButton', {read: ElementRef}) aboutButton;

  @ViewChild('contact', {read: ElementRef}) contact;
  @ViewChild('contactButton', {read: ElementRef}) contactButton;

  @ViewChild('profile', {read: ElementRef}) profile;
  @ViewChild('profileButton', {read: ElementRef}) profileButton;

  @Output() searchFor = new EventEmitter()
  @Output() reloadMainPostData = new EventEmitter()


  constructor(private fb: FormBuilder, private renderer: Renderer2, public auth: AuthService) { }

  ngOnInit(): void {
    this.SearchForm = this.fb.group({
        search: '',
        category: ''
    })

    this.SearchForm.valueChanges.subscribe( data => {
      if (this.SearchForm.value["search"] !== "" && this.SearchForm.value["category"]) {
        this.empty = false
      }

      else {
        this.empty = true
      }

    })
  }

  get categoryGet() {
    return this.SearchForm.get('category').value
  }


  searchItem = () => {
    this.searching = this.SearchForm.get("search").value
    this.categoryVal = this.SearchForm.get("category").value
    this.searchFor.emit([this.SearchForm.get("search").value, this.SearchForm.get("category").value])
  }

  valHandler = (val) => {
    if (this.navVal === val) {
      this.about.nativeElement.style.display = 'none'
      this.renderer.removeClass(this.aboutButton.nativeElement,'activated')
      this.contact.nativeElement.style.display = 'none'
      this.renderer.removeClass(this.contactButton.nativeElement,'activated')  
      if (this.profile !== undefined) {
      this.profile.nativeElement.style.display = 'none'
      this.renderer.removeClass(this.profileButton.nativeElement,'activated')
      }
      this.navVal = ''
    }

    else if (val === 'about') {
      this.navVal = 'about'
      this.about.nativeElement.style.display = 'flex'
      this.renderer.addClass(this.aboutButton.nativeElement,'activated')
      this.contact.nativeElement.style.display = 'none'
      this.renderer.removeClass(this.contactButton.nativeElement,'activated')  
      if (this.profile !== undefined) {
        this.profile.nativeElement.style.display = 'none'
        this.renderer.removeClass(this.profileButton.nativeElement,'activated')  
      }
    }
    
    else if (val === 'contact') {
      this.navVal = 'contact'
      this.contact.nativeElement.style.display = 'flex'
      this.renderer.addClass(this.contactButton.nativeElement,'activated')
      this.about.nativeElement.style.display = 'none'
      this.renderer.removeClass(this.aboutButton.nativeElement,'activated')  
      if (this.profile !== undefined) {
        this.profile.nativeElement.style.display = 'none'
        this.renderer.removeClass(this.profileButton.nativeElement,'activated')
      }
    }
    else {
      this.navVal = 'profile'
      this.profile.nativeElement.style.display = 'flex'
      this.renderer.addClass(this.profileButton.nativeElement,'activated')

      this.about.nativeElement.style.display = 'none'
      this.renderer.removeClass(this.aboutButton.nativeElement,'activated')
      this.contact.nativeElement.style.display = 'none'
      this.renderer.removeClass(this.contactButton.nativeElement,'activated') 
    }
  }

  pageTurnedLeft(IDS): void {
    if (IDS[6] === 'post') {

      if (IDS[0] === false) {
        this.profilePages[IDS[6]] = IDS[2]
      }
      else {
        this.profilePages[IDS[6]]--
      }
    }

    else {
      if (IDS[3] === false) {
        this.profilePages[IDS[6]] = IDS[5]
      }
      else {
        this.profilePages[IDS[6]]--
      }
    }
  }

  pageTurnedRight(IDS): void {   
    if (IDS[6] === 'post') {
      if (IDS[1] === false) {
        this.profilePages[IDS[6]] = 1
      }
      else {
        this.profilePages[IDS[6]]++
      }
    }

    else {
      if (IDS[4] === false) {
        this.profilePages[IDS[6]] = 1
      }
      else {
        this.profilePages[IDS[6]]++
      }
    }
  }

  grandParentX(val) {
    this.reloadMainPostData.emit(val)
  }
  
}
